import React from 'react';
import './App.css';
import PasswordGate from './components/PasswordGate';
import SiteHeader from './components/SiteHeader';
import Hero from './components/Hero';
import IdentitySection from './sections/IdentitySection';
import DesignSection from './sections/DesignSection';
import AudienceSection from './sections/AudienceSection';
import CopySection from './sections/CopySection';
import JourneySection from './sections/JourneySection';
import SiteFooter from './components/SiteFooter';

function App() {
  return (
    <PasswordGate>
      <div className="site-shell">
        <SiteHeader />
        <main>
          <Hero />
          <IdentitySection />
          <DesignSection />
          <AudienceSection />
          <CopySection />
          <JourneySection />
        </main>
        <SiteFooter />
      </div>
    </PasswordGate>
  );
}

export default App;